// 全局样式表（antdv）
export const customerTheme = {
  token: {
    // 主题色
    colorPrimary: '#FF9595',
    // 触发背景色
    controlItemBgActive:'rgba(255,149,149,0.2)',
    // 默认文本颜色
    colorText:'#333',
    // 一级边框
    colorBorder:'#FF9595',
    colorBgTextHover:'rgba(255,149,149,0.2)',
  }
}


// 全局样式表 vant

export const themeVar = {
  primaryColor: '#FF9595',
}
